const ADD_ANNOTATION = 'annotations/ADD_ANNOTATION';
const UPDATE_ANNOTATION = 'annotation/UPDATE_ANNOTATION';
const REMOVE_ANNOTATION = 'annotations/REMOVE_ANNOTATION';
const FILTER_ANNOTATIONS = 'annotations/FILTER_ANNOTATIONS';
const MUST_RENDER_FALSE = 'MUST_RENDER_FALSE';

function addAnnotation() {
  return { type: ADD_ANNOTATION };
}

function updateAnnotation(prop, payload, index) {
  return { type: UPDATE_ANNOTATION, index, prop, payload };
}

function removeAnnotation(index) {
  return { type: REMOVE_ANNOTATION, index };
}

function filterAnnotations(data, mustCheckSeries) {
  return { type: FILTER_ANNOTATIONS, data, mustCheckSeries };
}

export {
  ADD_ANNOTATION,
  UPDATE_ANNOTATION,
  REMOVE_ANNOTATION,
  FILTER_ANNOTATIONS,
  MUST_RENDER_FALSE,
  addAnnotation,
  updateAnnotation,
  removeAnnotation,
  filterAnnotations,
};
